import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const ReleaseCycleStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({ stepRun }) => {
    return <div>Release Cycle Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
